import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/Landingpage.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "information_image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "information_image_size",
    alt: "Imagen",
    src: _imports_0
  })
], -1)
const _hoisted_2 = { class: "information_content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "information_title information_title_h1" }, [
  /*#__PURE__*/_createTextVNode("Tenemos disponible para ti el servicio de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("transmisión del documento soporte de pago de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "Nómina Electrónica"),
  /*#__PURE__*/_createTextVNode(" según lo expedido por la "),
  /*#__PURE__*/_createElementVNode("span", null, "DIAN"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Realiza todos tus procesos en un mismo lugar. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Recuerda que somos tu mejor aliado estratégico.")
], -1)
const _hoisted_4 = { class: "information_title information_title_h2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "information_contentbutton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", _hoisted_4, [
        _createTextVNode("Si tienes dudas o quieres conocer más, haz clic "),
        _createElementVNode("a", {
          class: "information_title_link",
          href: $setup.landing_page,
          target: "_blank"
        }, "aquí", 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "information_contentbutton_button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToQualification()))
        }, "Continuar")
      ])
    ])
  ]))
}